import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { mergeNeighborhoodMapIntoEntries } from 'src/redux/content/utils/mergeNeighborhoodMapIntoEntries';
import { mergeTaxonomyContentEntryIntoEntries } from 'src/redux/content/utils/mergeTaxonomyContentEntryIntoEntries';
import type { TaxonomyPlpNeighborhoodEntry } from 'src/services/contentstack/taxonomyNeighborhood/types';
import type { ReduxContentState, TaxonomyContentEntry } from './types';

export const initialState: ReduxContentState = {};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {
    mergeNeighborhoodMap: (state, { payload }: PayloadAction<TaxonomyPlpNeighborhoodEntry[]>) => {
      state.entries = mergeNeighborhoodMapIntoEntries(state.entries ?? [], payload);
    },
    mergeEntryContent: (state, { payload }: PayloadAction<TaxonomyContentEntry>) => {
      state.entries = mergeTaxonomyContentEntryIntoEntries(state.entries ?? [], payload);
    },
  },
});
